import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className='footer px-[10px] md:px-[50px] lg:px-[70px] xl:px-[100px] bg-[#F1F8FF]'>
      <div>
        <Link to="https://wa.me/628983862898" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/CS.png`} alt="FamilyMart Indonesia" className="fixed bottom-5 right-5 w-[60px] md:w-[70px] lg:w-[70px] xl:w-[100px]"
        /></Link>
      </div>
      <div className='flex justify-center gap-5 items-center'>
        <Link to="/" className="bg-[#fafafa40] px-12 md:px-12 lg:px-10 py-1 md:py-1 lg:py-3 text-sky-500 font-bold rounded">Home</Link>
        <Link to="/promo" className="bg-[#fafafa40] px-12 md:px-12 lg:px-10 py-1 md:py-1 lg:py-3 text-sky-500 font-bold rounded">Promo</Link>
      </div>
      <div className='block md:flex justify-between mt-5 px-5 md:px-0'>
        <div>
          <p className='text-center md:text-left text-sm lg:text-xl xl:text-2xl text-sky-500 font-extrabold'>Unlock more rewards with FamiApps!</p>
          <div className="flex mt-1 md:mt-5 justify-center md:justify-start">
            <div>
              <img src={`${process.env.PUBLIC_URL}/media/images/icon-famiapps.png`} className="w-[65px] md:w-[80px] lg:w-[100px] xl:w-[140px]" alt="FamilyMart Indonesia" />
            </div>
            <div className='ml-5'>
              <div><Link to="https://play.google.com/store/apps/details?id=com.familymartindonesia.fmi_app" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/googleplay.png`} className="w-[100px] md:w-[130px] lg:w-[150px] xl:w-[200px]" alt="FamilyMart Indonesia" /></Link></div>
              <div><Link to="https://apps.apple.com/id/app/famiapps-by-familymartid/id1597478434?l=id" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/appstore.png`} className="w-[100px] md:w-[130px] lg:w-[150px] xl:w-[200px]" alt="FamilyMart Indonesia" /></Link></div>
            </div>
          </div>
        </div>
        <div className='flex md:block justify-between mt-3 md:mt-0'>
          <div>
            <p className='text-sm lg:text-xl xl:text-2xl text-sky-500 font-extrabold text-left md:text-right'>Let's get in touch!</p>
            <div className='flex items-center justify-end mt-2 md:mt-5 mb-3'>
              <div><img src={`${process.env.PUBLIC_URL}/media/images/Whatsapp.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px] mr-3" alt="FamilyMart Indonesia" /></div>
              <Link to="https://wa.me/628983862898" target={"_blank"} className='text-sky-500 font-bold text-xs md:text-sm'>0898-3862-898</Link>
            </div>
          </div>
          <div>
            <p className='text-sm lg:text-xl xl:text-2xl text-sky-500 font-extrabold text-right'>Find us on:</p>
            <div className='flex items-center justify-end mt-2 md:mt-5'>
              <Link to="https://www.instagram.com/familymartid/" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Instagram.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://web.facebook.com/FamilyMartID" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Facebook.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://www.tiktok.com/@familymartindonesia" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Tiktok.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://x.com/FamilyMart_ID" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Twitter.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
            </div>
          </div>
        </div>
      </div>
      <hr className="border-1 md:border-2 border-solid border-cyan-600 my-2" />
      <p className='text-sky-500 text-xs md:text-sm'>Copyright &copy; 2022 PT Fajar Mitra Indah</p>
    </footer>
  );
};

export default Footer;